import { slices, useAppSelector } from 'src/redux';

const { selectors: userSelectors } = slices.user;
const { selectors: lastRouteSelectors } = slices.lastRoute;

const lastRoute = () => {
  const userDetails = useAppSelector(userSelectors.selectUserInfo);
  const lastRoutePath = useAppSelector(lastRouteSelectors.selectLastRoute);
  const lastUser = useAppSelector(lastRouteSelectors.selectLastUser);

  const getRedirectPath = () => {
    // If no last route saved, go to welcome page
    if (!lastRoutePath) {
      return '/app/welcome-page';
    }

    try {
      if (lastUser === userDetails?.id && lastRoutePath !== '/login') {
        return lastRoutePath || '/app/welcome-page';
      }
    } catch (error) {
      console.warn('Invalid last_route data in sessionStorage:', error);
    }

    return '/app/welcome-page';
  };

  return {
    getRedirectPath
  };
};

export default lastRoute;
